<div class="row" #roleContainerRef>
    <div class="col-12" *ngIf="topLevelRoles?.length">
        <span class="fw-light small text-muted">Top: </span>
        <ng-container>
            <span class="px-2 border badge bg-light border-secondary text-dark fw-normal me-1" *ngFor="let role of topLevelRoles?.slice(0,lengthToShow)">{{userRolesMap[role?.role]?.roleName || '-'}}</span>
        </ng-container>
        <ng-container *ngIf="roleContainerRef?.showRemainingTopLevelRoles">
            <span class="px-2 border badge bg-light border-secondary text-dark fw-normal me-1" *ngFor="let role of topLevelRoles?.slice(lengthToShow)">{{userRolesMap[role?.role]?.roleName || '-'}}</span>
        </ng-container>
        <span class="text-primary small pointer" *ngIf="topLevelRoles?.slice(lengthToShow)?.length" (click)="roleContainerRef['showRemainingTopLevelRoles'] = roleContainerRef['showRemainingTopLevelRoles'] ? false : true; ">
            show {{roleContainerRef['showRemainingTopLevelRoles'] ? 'less' : 'more'}}
        </span>
    </div>
    <!-- <hr class="my-1 border-dark" style="border-style: dashed; min-width: calc(100% - 25rem); max-width: calc(100%-3rem);"> -->
    <ng-container *ngIf="flow === 'domain'">
        <div class="mt-1 col-12" *ngIf="resourceLevelRoles?.length">
            <span class="fw-light small text-muted">Resource: </span>
            <ng-container>
                <span class="px-2 border badge bg-light border-secondary text-dark fw-normal me-1" *ngFor="let role of resourceLevelRoles?.slice(0,lengthToShow)">
                    {{(domainResourceMap[role?.domainResourceId]?.value || '')}}
                    <i class="mt-1 mdi mdi-arrow-right"></i>
                    {{userRolesMap[role?.role]?.roleName || '-'}}
                </span>
            </ng-container>
            <ng-container *ngIf="roleContainerRef?.showRemainingResourceLevelRoles">
                <span class="px-2 border badge bg-light border-secondary text-dark fw-normal me-1" *ngFor="let role of resourceLevelRoles?.slice(lengthToShow)">
                    {{(domainResourceMap[role?.domainResourceId]?.value || '')}}
                    <i class="mt-1 mdi mdi-arrow-right"></i>
                    {{userRolesMap[role?.role]?.roleName || '-'}}
                </span>
            </ng-container>
            <span class="text-primary small pointer" *ngIf="resourceLevelRoles?.slice(lengthToShow)?.length" (click)="roleContainerRef['showRemainingResourceLevelRoles'] = roleContainerRef['showRemainingResourceLevelRoles'] ? false : true; ">
               show {{roleContainerRef['showRemainingResourceLevelRoles'] ? 'less' : 'more'}}
            </span>
        </div>
    </ng-container>
</div>